import { Center, Text } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import SetPasswordForm from '../../components/others/forms/SetPasswordForm';
import SplashScreen from '../../components/others/SplashScreen';
import fb from '../../services/firebase.service';
import useErrors from '../../utils/hooks/errors.hooks';
import useSnacks from '../../utils/hooks/snacks.hooks';
import getQueryParam from '../../utils/query-param.utils';
import Copyright from '../landing/Copyright';

interface ResetPasswordPageProps {}

const ResetPasswordPage: React.FC<ResetPasswordPageProps> = () => {
  const handleErr = useErrors();
  const { showSuccess } = useSnacks();

  // TODO: tx

  const [loading, setLoading] = useState(true);
  const [formLoading, setFormLoading] = useState(false);
  const [email, setEmail] = useState<string>();

  const actionCode = useMemo(() => getQueryParam('oobCode'), []);

  useEffect(() => {
    const verifyActionCode = async () => {
      if (!actionCode) {
        window.location.replace('/');
        return;
      }

      try {
        const email = await fb.auth().verifyPasswordResetCode(actionCode);
        setEmail(email);
        setLoading(false);
      } catch (err) {
        window.location.replace('/');
        return;
      }
    };

    verifyActionCode();
  }, [actionCode]);

  async function handleSubmit(password: string) {
    setFormLoading(true);

    try {
      await fb.auth().confirmPasswordReset(actionCode!, password);
      showSuccess();
      await fb.auth().signInWithEmailAndPassword(email!, password);
      window.location.replace('/');
    } catch (err) {
      handleErr(err);
      setFormLoading(false);
    }
  }

  if (loading) return <SplashScreen />;

  return (
    <Center h="100%" flexDirection="column">
      <Center flexDirection="column">
        <Text mb={2} fontWeight="700" fontSize={24}>
          {'Kolumboos PMS'}
        </Text>

        <Text fontSize={17} color="gray.400" mb="10px">
          {'Reset password'}
        </Text>

        <SetPasswordForm loading={formLoading} handleSubmit={handleSubmit} isReset />
      </Center>
      <Copyright />
    </Center>
  );
};

export default ResetPasswordPage;
